export const actionTypes = {
    SET_CONVERSION_CHART_DATA: 'SET_CONVERSION_CHART_DATA',
    SET_CONVERSION_CHART_CANCEL_TOKEN: 'SET_CONVERSION_CHART_CANCEL_TOKEN',
    IS_CONVERSION_CHART_FETCHING: 'IS_CONVERSION_CHART_FETCHING'
}